import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const NavArrow = ({ direction, onClick, visible }) => {
    const isLeft = direction === 'left';
    
    if (!visible) return null; 

    return (
        <div 
            className={isLeft ? "leftContent" : "rightContent"}
            onClick={onClick}
            style={{ cursor: "pointer" }}
        >
            {isLeft 
                ? <ChevronLeftIcon className="arrowIcon"/> 
                : <ChevronRightIcon className="arrowIcon"/>
            }
        </div>
    );
};
export default NavArrow;